    <div>
        <div class="f100 clear" id="tyWrap">
            <h3 class="tyWrap-head"> Thank you</h3>
            <div class="label-container">
                <span class="info-label bold">Payment has been applied successfully.</span>
            </div>
            <div class="label-container">
                <div>
                    <span class="info-label bold">Group Bill Number: </span><span class="info-label-value">{{groupBillNo}}</span> 
                </div>
                <div>
                    <span class="info-label bold">Amount Applied:</span><span class="info-label-value">{{amount | currency:'USD':'symbol-narrow':'1.2-2'}}</span>
                </div>
                <div>
                    <span class="info-label bold">Purchase Order Number:</span><span class="info-label-value">{{poNumber}}</span>
                </div>
                <div>
                    <span class="info-label bold">Total Applicants:</span><span class="info-label-value">{{totalMember}}</span>
                </div>
            </div>
            <br />
        </div>
    </div>